import React from 'react';
import { motion } from 'framer-motion';

export default function CustomCheckbox({ isSelected, onChange, isDisabled, children, name }) {
  const checkVariants = {
    checked: { pathLength: 1, opacity: 1, transition: { duration: 0.2, delay: 0.1 } },
    unchecked: { pathLength: 0, opacity: 0, transition: { duration: 0.2 } },
  };

  const boxVariants = {
    checked: {
      backgroundColor: '#3b82f6', // Tailwind blue-500
      borderColor: '#3b82f6',
      transition: { duration: 0.2 },
    },
    unchecked: {
      backgroundColor: 'transparent',
      borderColor: '#d1d5db', // Tailwind gray-300
      transition: { duration: 0.2 },
    },
  };

  return (
    <label
      className={`flex items-center gap-2 cursor-pointer ${
        isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'
      }`}
    >
      <div className="relative flex items-center justify-center">
        <input
          type="checkbox"
          name={name}
          className="absolute opacity-0 w-0 h-0"
          checked={isSelected}
          onChange={(e) => {
            if (!isDisabled && onChange) {
              onChange(e);
            }
          }}
          disabled={isDisabled}
        />
        <motion.div
          className="w-5 h-5 flex flex-shrink-0 items-center justify-center rounded border-2"
          variants={boxVariants}
          initial={false}
          animate={isSelected ? 'checked' : 'unchecked'}
        >
          <motion.svg
            className="w-3.5 h-3.5 text-white pointer-events-none"
            viewBox="0 0 14 14"
            fill="none"
          >
            <motion.path
              d="M3 7.5L5.5 10L11 4"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              variants={checkVariants}
              initial={false}
              animate={isSelected ? 'checked' : 'unchecked'}
            />
          </motion.svg>
        </motion.div>
      </div>
      <span className="text-sm text-gray-700 select-none">{children}</span>
    </label>
  );
}
